import React from 'react';
import PropTypes from 'prop-types';
import {Collapse} from "reactstrap";

ProfileAboutPage.propTypes = {
    contentList: PropTypes.array.isRequired,
    payload: PropTypes.object.isRequired,
};

function ProfileAboutPage(props) {
    return (
        <Collapse isOpen={true} style={{padding: 16}}>
            <div className="premium-content-modal-tags">Channel description</div>
            <div className="premium-content-modal-description">
                {props.payload.summary.broadcaster.channel_description}
            </div>
            {
                props.contentList && props.contentList.length > 0 && props.contentList[0].hasOwnProperty("tags") &&
                <div className="premium-content-modal-tags">
                    Tags
                    <div style={{marginTop:10}}>
                        {
                            props.contentList[0].tags.map((tag, index) => {
                                return (
                                    <span className="premium-content-modal-tag"
                                          key={`premium-content-modal-tag-${index}`}>{tag.name}</span>
                                )
                            })
                        }
                    </div>
                </div>
            }
        </Collapse>
    );
}

export default ProfileAboutPage;